// Extract all possible paths from a nested object
export const extractPaths = (obj, prefix = "", paths = []) => {
  if (obj === null || typeof obj !== "object") {
    return paths;
  }

  Object.entries(obj).forEach(([key, value]) => {
    const currentPath = prefix ? `${prefix}.${key}` : key;
    if (value !== null && typeof value === "object" && !Array.isArray(value)) {
      extractPaths(value, currentPath, paths);
    } else if (Array.isArray(value) && value.length > 0 && typeof value[0] === "object") {
      // For arrays, add the array path and extract from first item
      paths.push({ path: currentPath, type: "array", sample: value[0] });
      extractPaths(value[0], `${currentPath}[0]`, paths);
    } else {
      paths.push({ path: currentPath, type: typeof value, sample: value });
    }
  });

  return paths;
};
